import { MicroviewCommunicationChannel } from '../MicroviewCommunicationChannel';

export class MicroViewBundleReadyChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'MicroViewBundleReadyChannel';
  public namespace: string = 'MicroView';
}

export class MicroViewRenderChannel extends MicroviewCommunicationChannel<unknown, void> {
  public name: string = 'MicroViewRenderChannel';
  public namespace: string = 'MicroView';
}

export class MicroViewDisposeChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'MicroViewDisposeChannel';
  public namespace: string = 'MicroView';
}

export class MicroViewPropsChangeChannel extends MicroviewCommunicationChannel<unknown, void> {
  public name: string = 'MicroViewPropsChangeChannel';
  public namespace: string = 'MicroView';
}

export class MicroViewFirstTimeRenderChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'MicroViewFirstTimeRenderChannel';
  public namespace: string = 'MicroView';
}
